import { usePostHog } from 'posthog-js/react';
import { PopupModal, useCalendlyEventListener } from 'react-calendly';
import { CalendlyProps } from './Calendly';

const CalendlyModal = (props: CalendlyProps) => {
  const posthog = usePostHog();

  useCalendlyEventListener({
    onProfilePageViewed: () => posthog.capture('Calendly Profile Viewed'),
    onDateAndTimeSelected: () => posthog.capture('Calendly Date And Time Selected'),
    onEventTypeViewed: () => posthog.capture('Calendly Event Type Viewed'),
    onEventScheduled: (event) => {
      posthog.capture('Calendly Event Scheduled', { event });
    },
  });

  const { utmParams, prefill, isOpen, setIsOpen, eventSlug, onClose = null } = props;
  return (
    <PopupModal
      url={`https://calendly.com/${eventSlug}`}
      rootElement={typeof document !== 'undefined' ? document.getElementById('__next') : null}
      utm={utmParams}
      prefill={prefill}
      pageSettings={{
        hideEventTypeDetails: false,
        hideLandingPageDetails: true,
        hideGdprBanner: true,
      }}
      onModalClose={() => {
        setIsOpen(false);
        if (onClose) onClose();
      }}
      open={isOpen}
    />
  );
};

export default CalendlyModal;
